<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap>
        <v-flex xs6>
          <h6>{{ $t('close_ticket') }}</h6>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn fab small flat @click="handleReset">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('status') }">
          <div class="caption mb-1 mt-2">Status *</div>
          <v-autocomplete
            v-model="status"
            v-validate="'required'"
            name="status"
            :items="statusOptions"
            outline
            clearable
            class="default-input"
            single-line
            :hide-details="!errors.has('status')"
            :error="errors.has('status')"
            :error-messages="errors.first('status')"
            placeholder="Status"
          />
        </v-flex>
        <v-flex xs12 class="mb-2">
          <div class="caption mb-1 mt-2">Wrap up *</div>
          <WrapUpManage v-model="wrap_up_route" @onUpdateWrapUpData="handleUpdateWrapData" />
          <input
            v-model="wrap_up"
            v-validate="'required'"
            type="hidden"
            name="wrap_up"
            data-vv-as="Wrap up"
          />

          <div class="form-control" :class="{ 'has-error': errors.has('wrap_up') }">
            <p v-if="errors.has('wrap_up')" class="text-error">{{ errors.first('wrap_up') }}</p>
          </div>

          <div
            v-if="isShowNote"
            class="form-control px-1"
            :class="{ 'has-error': errors.has('note') }"
          >
            <v-textarea
              id="ticketNote"
              v-model="note"
              v-validate="!isWrapUpNoteNotRequired ? 'required' : ''"
              outline
              type="text"
              :placeholder="'Note'"
              class="default-input-textfield"
              maxlength="255"
              :data-vv-as="'Note'"
              name="note"
              :hide-details="!errors.has('note')"
              :error-messages="errors.first('note')"
              rows="3"
            />
          </div>
        </v-flex>
        <V-flex xs12>
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="handleReset">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="handleSubmit">{{ $t('close_ticket') }}</v-btn>
          </div>
        </V-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import WrapUpManage from './ttb/WrapUpManage.vue'
export default {
  components: {
    WrapUpManage
  },
  data() {
    return {
      status: '',
      statusOptions: ['closed without survey', 'closed by system'],
      wrap_up: '',
      wrap_up_route: '',
      note: ''
    }
  },
  computed: {
    isWrapUpNoteNotRequired() {
      return this.wrap_up_route.includes('Reject case')
    },
    isShowNote() {
      return (
        this.wrap_up === 'อื่นๆ' ||
        this.wrap_up === 'อื่นๆ (ที่จอดรถน้อย,ความสะอาด,ลิฟท์ ฯลฯ)' ||
        this.wrap_up === 'อื่นๆ (อาคารสำนักงานอื่นๆ)' ||
        this.wrap_up === 'ไม่เกี่ยวข้อง'
      )
    }
  },
  methods: {
    handleUpdateWrapData(data) {
      this.wrap_up = data
    },
    handleReset() {
      this.status = ''
      this.wrap_up = ''
      this.wrap_up_route = ''
      this.note = ''
      this.$emit('close')
    },
    async handleSubmit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        return
      }
      const payload = {
        status: this.status,
        wrap_up: this.wrap_up,
        wrap_up_route: this.wrap_up_route,
        note: this.note
      }
      this.$emit('submit', payload)
      this.handleReset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ticket/DialogCloseTicket.vue